"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
var hashmap_1 = __importDefault(require("hashmap"));
// @ts-ignore
var message_bus_1 = require("@wh/message-bus");
var TextUtils_1 = require("./utils/TextUtils");
var TOPIC_BASE = 'wh.common.command.dli.store.set';
var Store = /** @class */ (function () {
    function Store(name, root) {
        // NOTE property can be any if this is needed, but more strict typing is better here
        this.bucket = {};
        this.name = TextUtils_1.TextUtils.camelCasedSlugify(name);
        this.topicName = TOPIC_BASE + "." + this.name;
        this.bucket = new hashmap_1.default();
        try {
            this.pin(root);
        }
        finally {
            this.subscribe();
        }
    }
    Store.prototype.pin = function (root) {
        if (!root.WH) {
            root.WH = new Object();
        }
        if (!root.WH.storages) {
            root.WH.storages = new Object();
        }
        root.WH.storages[this.name] = this;
    };
    Store.prototype.subscribe = function () {
        var _this = this;
        message_bus_1.subscribe({
            topic: this.topicName,
            callback: function (message) {
                var _a;
                (_a = _this.bucket).multi.apply(_a, message.data.reduce(function (current, item) {
                    return current.concat([item.key, item.value]);
                }, []));
            }
        });
    };
    /**
     * PUBLIC methods
     *
     */
    Store.getInstance = function (name, root) {
        if (root === void 0) { root = global; }
        return !root.WH || !root.WH.storages || !root.WH.storages[name] ?
            new this(name, root) :
            root.WH.storages[name];
    };
    Store.prototype.get = function (key) {
        return this.bucket.get(key);
    };
    Store.prototype.getEntries = function () {
        return this.bucket.entries().reduce(function (current, item) {
            current[item[0]] = item[1];
            return current;
        }, {});
    };
    Store.prototype.set = function (key, value) {
        this.bucket.set(key, value);
    };
    Store.prototype.setEntries = function (entries) {
        var _a;
        (_a = this.bucket).multi.apply(_a, entries.reduce(function (current, item) {
            return current.concat([item.key, item.value]);
        }, []));
    };
    Store.prototype.getTopic = function () {
        return this.topicName;
    };
    Store.prototype.has = function (propertyName) {
        return this.bucket.has(propertyName);
    };
    Store.prototype.purge = function () {
        this.bucket.clear();
    };
    Store.prototype.remove = function (propertyName) {
        this.bucket.delete(propertyName);
    };
    return Store;
}());
exports.Store = Store;
